import React from "react";
import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";

import InternshipImg from "../assets/internship-img.jpeg";
import CareerPathImage from "../assets/Career-path.jpeg";

const Background = styled("div")({
  background: "white",
  minHeight: "60vh",
  padding: "80px 20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

const GradientText = styled(Typography)({
  fontWeight: "bold",
  background: "Black",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontSize: "3rem",
  letterSpacing: "1.5px",
});

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: "#D9D9D9",
  color: "#333",
  borderRadius: "20px",
  padding: "100px 10px",
  boxShadow: "0 12px 30px rgba(0,0,0,0.1)",
  textAlign: "center",
  transition: "transform 0.4s ease, box-shadow 0.4s ease",
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  },
}));

const StyledButton = styled(Button)({
  marginTop: "20px",
  padding: "12px 28px",
  borderRadius: "30px",
  textTransform: "none",
  fontWeight: 600,
  transition: "all 0.3s ease",
  background: "#F19F4D",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 8px 20pxhsl(30, 85.40%, 62.40%)",
  },
});

const StyledImage3D = styled("img")({
  width: "100%",
  maxHeight: "300px",
  objectFit: "cover",
  borderRadius: "12px",
  marginBottom: "20px",
  transition: "transform 0.6s ease, box-shadow 0.6s ease",
  boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    transform: "rotateY(10deg) rotateX(10deg) scale(1.05)",
    boxShadow: "0 14px 28px rgba(0, 0, 0, 0.3)",
  },
});


const Careers = () => {
  const navigate = useNavigate();

  return (
    <Background>
      <Container maxWidth="lg">
        <Box mb={8} textAlign="center">
          <GradientText variant="h2" component="h1" fontfamily="Helvetica" gutterBottom>
            Careers at Our Company <br />
          </GradientText>
          <Typography
            variant="h6"
            color="textSecondary"
            fontWeight="500"
            lineHeight="1.5"
          >
            Find the right opportunity for your career growth.
          </Typography>
        </Box>

        <Grid container spacing={5} justifyContent="center">
          {/* Internship Card */}
          <Grid item xs={12} sm={10} md={6}>
  <StyledCard>
    <CardContent>
    <Typography variant="h4" fontWeight="bold" gutterBottom>
        Internship/Job 
      </Typography>
      <StyledImage3D src={InternshipImg} alt="3D Internship Visual" /><br />
      <Typography variant="body1" color="textSecondary">
  Dedicated and enthusiastic candidate, <br />
  seeking an opportunity to apply technical skills and <br />
  mindset in a challenging and growth-oriented environment. <br />
  Eager to contribute to real-world projects, <br />
  learn from industry experts, <br />
  and be a valuable asset to our team.
</Typography>

      <StyledButton
        variant="contained"
        color="#F19F4D"
        onClick={() => navigate("/careerpage")}
      >
        Apply Now
      </StyledButton>
    </CardContent>
  </StyledCard>
</Grid>

          {/* Career Path Card */}
          <Grid item xs={12} sm={10} md={6}>
  <StyledCard>
    <CardContent>
    <Typography variant="h4" fontWeight="bold" gutterBottom>
        Career Path
      </Typography>
      <StyledImage3D src={CareerPathImage} alt="3D Career Path Visual" />
      <Typography variant="body1" color="textSecondary">
      Driven by curiosity and a passion for innovation, <br />
      We aim to build a successful career in Tech, <br />
      focusing on continuous learning, skill enhancement, <br />
      and meaningful contributions to cutting-edge projects. ,<br />
      Our goal is to grow as a professional while <br />
      adding value to the organization and society.
      </Typography>
      <StyledButton
        variant="contained"
        color="#F19F4D"
        onClick={() => navigate("/career-paths")}
      >
        Explore
      </StyledButton>
    </CardContent>
  </StyledCard>
</Grid>

        </Grid>
      </Container>
    </Background>
  );
};

export default Careers;
